import { render, staticRenderFns } from "./liveDiscussion.vue?vue&type=template&id=f795f5c4&"
import script from "./liveDiscussion.vue?vue&type=script&lang=js&"
export * from "./liveDiscussion.vue?vue&type=script&lang=js&"
import style0 from "./liveDiscussion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports